export default __webpack_public_path__ + "static/Plain-Light-820803f3ac92b2dde0794dceb1cf3beb.woff";